import Toast from "../../component/toastify/Index";
import axios from "../../axios/interceptor";

export const getCustomerProfileDetails = async () => {
    try {
        const response = await axios.get('/customer/profile/getCustomerProfile')
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateCustomerProfileDetails = async (payload) => {
    try {
        const response = await axios.put('/customer/profile/updateCustomerProfile', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateCustomerLanguage = async (payload) => {
    try {
        const response = await axios.put('/customer/profile/updateCustomerLanguage', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateCustomerPassword = async (payload) => {
    try {
        const response = await axios.put('/customer/profile/changeCustomerProfilePassword', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}